import { render, staticRenderFns } from "./ThresholdManagement.vue?vue&type=template&id=71d385ac&scoped=true&"
import script from "./ThresholdManagement.vue?vue&type=script&lang=js&"
export * from "./ThresholdManagement.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdManagement.vue?vue&type=style&index=0&id=71d385ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d385ac",
  null
  
)

export default component.exports